module.exports = __webpack_public_path__ + "static/media/profyle-process.8ad7a694.jpg";